import { makeAutoObservable } from 'mobx';
import { FAILURE, REQUEST, SUCCESS, UNSET } from '../../constants/status';
class server {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
  homeStatus = 1
  status = UNSET;

  request = () => {
    this.status = REQUEST;
  };
  request_success = () => {
    this.status = SUCCESS;
  };
  request_fail = () => {
    this.status = FAILURE;
  };
  changeHomeStatue = (sum) => {
    this.homeStatus = sum
  }
}
export default server;
